import { Link } from '@tanstack/react-router'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PlanFinePrint, StartFreeButton } from '@/components/marketing/free-plan-cta'
import { useFreePlan } from '@/hooks/use-free-plan'

export function Cta() {
  const free = useFreePlan()
  return (
    <section>
      <div className="container mx-auto px-4 py-12 md:py-[72px]">
        <div className="flex flex-col items-center rounded-frame border border-border bg-card p-8 text-center shadow-raised md:p-12">
          <h2 className="text-balance text-[1.75rem] font-semibold leading-tight tracking-tight md:text-headline">See every step still works.</h2>
          <p className="mt-3 max-w-xl text-lead text-body">
            {free.isOpen
              ? `Point Uptrack at your login, signup, and checkout — or start free with ${free.monitors} monitors at ${free.intervalSeconds}-second intervals. Set up your first monitor in under a minute.`
              : 'Point Uptrack at your login, signup, and checkout — or choose a paid plan with checks at 30-second intervals. Set up your first monitor in under a minute.'}
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <StartFreeButton />
            <Button size="lg" variant={free.isOpen ? 'outline' : 'default'} className="h-11 px-5 text-[15px]" asChild>
              <Link to="/pricing">
                See plans
                {!free.isOpen && <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" />}
              </Link>
            </Button>
          </div>
          <PlanFinePrint className="mt-3" />
        </div>
      </div>
    </section>
  )
}
